import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {repoRouteBuilder} from '../config/repo-route-builder'
import type {RepoTaskPayload} from '../types/repo-agents-payload'
import {noticeDismissalRouteQuery} from './notice-dismissal-route-query'

/**
 * Task detail page route configuration (pull-based URL).
 * @deprecated This route is kept for backward compatibility while the backend
 * redirect (behind :copilot_agents_pull_redirect_to_task FF) is rolling out.
 * Remove once the redirect is fully enabled and this route is no longer served as HTML.
 */
export function buildRepoTaskRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoTaskRoute', {
    path: '/:owner/:repo/agents/pull/:pullNumber',
    queries: [mainQuery<RepoTaskPayload>(), noticeDismissalRouteQuery],
  })
}

export const repoTaskRoute = buildRepoTaskRoute(repoRouteBuilder)

/**
 * Task detail page route configuration (Task ID-based URL).
 */
export function buildRepoTaskByIdRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoTaskByIdRoute', {
    path: '/:owner/:repo/tasks/:taskId',
    queries: [mainQuery<RepoTaskPayload>(), noticeDismissalRouteQuery],
  })
}

export const repoTaskByIdRoute = buildRepoTaskByIdRoute(repoRouteBuilder)
